import { createContext, useContext } from 'react'

const PackageDataContext = createContext()
const PurchasedPackageContext = createContext()

export const PackageDataProvider = PackageDataContext.Provider
export const PurchasedPackageDataProvider = PurchasedPackageContext.Provider

export const usePackagePageData = () => {
  const value = useContext(PackageDataContext)
  if (value === undefined) {
    throw new Error('usePackagePageData must be used within a PackageDataProvider')
  }
  return value
}

export const usePurchasedPackage = () => {
  const value = useContext(PurchasedPackageContext)
  if (value === undefined) {
    throw new Error('usePurchasedPackage must be used within a PurchasedPackageDataProvider')
  }
  return value
}
